import { render } from "./ImagesSlider.vue?vue&type=template&id=7b5ff3ab&scoped=true&ts=true"
import script from "./ImagesSlider.vue?vue&type=script&lang=ts"
export * from "./ImagesSlider.vue?vue&type=script&lang=ts"

import "./ImagesSlider.vue?vue&type=style&index=0&id=7b5ff3ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5ff3ab"]])

export default __exports__